import { action } from '@ember/object';
import type Owner from '@ember/owner';
import { service } from '@ember/service';

import moment from 'moment';

import type { PopupData, Service } from 'webapp-types';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import type { Args } from 'webapp/components/popup/inner/modal';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BillingPopupCardExpiringComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('analytics') declare analyticsService: Service.Analytics;
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('user-settings') declare userSettingsService: Service.UserSettings;

	constructor(owner: Owner, args: Args) {
		super(owner, args);

		this.analyticsService.event(TrackingEvent.CARD_EXPIRING_POPUP_SHOWN);
		void this.userSettingsService.save(
			UserSettingsKey.CARD_EXPIRING_SHOWN_TIMESTAMP,
			moment().unix(),
		);
	}

	@action
	confirm(): void {
		this.analyticsService.event(TrackingEvent.CARD_EXPIRING_POPUP_SHOWN_DONE);
		this.navigationService.transitionToRoute('settings.billing.stripe');

		this.close();
	}
	<template>
		<div class="title red-on-transparent">
			<CommonUiIconComponent @name="CreditCard" @size="lg" />
			<div class="text">
				Your payment information is about to expire
			</div>
		</div>

		<div class="content">

			<hr class="wider top" />

			<strong>
				The payment information you have for your Databox subscription (card ending with:
				{{this.billingService.paymentMethod.last4}}) is going to expire in a few days.
			</strong>

			<br /><br />

			<p>Please update your payment information to avoid account disruption.</p>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Update billing information"
						@size="big"
						@onTrigger={{this.confirm}}
					/>
				</div>
			</div>

		</div>
	</template>
}
